const API_BASE = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3010/api';

export interface TenantGridDTO {
  id: string;
  nombre: string;
  emailAdministrador: string;
  telefonoContacto?: string | null;
  activo: boolean;
  estado: string;
  fechaActivoUTC: string;
  fechaVencimiento?: string | null;
  baseDeDatos: string;
  timeZoneId: string;
  planAdminId?: number | null;
  planNombre?: string | null;
}

export interface TenantFormDTO {
  nombre: string;
  emailAdministrador: string;
  telefonoContacto?: string | null;
  baseDeDatos: string;
  timeZoneId?: string;
  fechaVencimiento?: string | null;
  planAdminId?: number | null;
}

export interface TenantPlanOptionDTO {
  id: number;
  nombre: string;
}

async function requestJson<T>(token: string, path: string, init?: RequestInit): Promise<T> {
  let response: Response;
  try {
    response = await fetch(`${API_BASE}${path}`, {
      ...init,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        ...(init?.headers ?? {}),
      },
    });
  } catch {
    throw new Error('network_error');
  }

  if (!response.ok) {
    const body = await response.json().catch(() => null) as { error?: string } | null;
    throw new Error(body?.error ?? 'request_failed');
  }

  if (response.status === 204) return undefined as T;
  return await response.json() as T;
}

export function listTenants(token: string): Promise<TenantGridDTO[]> {
  return requestJson<TenantGridDTO[]>(token, '/tenants');
}

export function listTenantPlans(token: string): Promise<TenantPlanOptionDTO[]> {
  return requestJson<TenantPlanOptionDTO[]>(token, '/tenants/plans');
}

export function createTenant(token: string, payload: TenantFormDTO): Promise<TenantGridDTO> {
  return requestJson<TenantGridDTO>(token, '/tenants', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function updateTenant(token: string, id: string, payload: TenantFormDTO): Promise<TenantGridDTO> {
  return requestJson<TenantGridDTO>(token, `/tenants/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export function changeTenantStatus(token: string, id: string): Promise<void> {
  return requestJson<void>(token, `/tenants/${encodeURIComponent(id)}/change-status-tenant`, {
    method: 'POST',
  });
}
